'use client'

import { useSearchParams } from 'next/navigation'
import { Suspense } from 'react'

import { KineticPageShell } from '../../../components/kinetic/KineticPageShell'
import { KineticWorkshopFooter } from '../../../components/kinetic/KineticWorkshopFooter'
import { Container } from '../../../components/layout/container'
import { LoadingSpinner } from '../../../components/ui/loading-spinner'
import { RegistrationWizard } from '../../../components/workshop/RegistrationWizard'

function KineticLoadingCard({ message }: { message: string }) {
  return (
    <div className="flex min-h-[50vh] items-center justify-center px-4">
      <div className="border-kinetic-outline-variant/30 w-full max-w-md border bg-kinetic-surface-container-low p-10 text-center">
        <LoadingSpinner />
        <p className="mt-4 font-mono text-[10px] uppercase tracking-wider text-kinetic-on-surface-variant">
          {message}
        </p>
      </div>
    </div>
  )
}

function RegistrationContent() {
  const searchParams = useSearchParams()
  const workshopId = searchParams.get('workshop')

  const handleRegistrationComplete = (registrationId: string) => {
    window.location.href = `/workshops/confirmation?registration=${registrationId}`
  }

  const handleCancel = () => {
    window.location.href = '/workshops'
  }

  return (
    <KineticPageShell>
      <div className="pb-8 pt-24">
        <Container width="large" size="custom">
          <p className="mb-3 font-mono text-[10px] uppercase tracking-[0.28em] text-kinetic-secondary-fixed">
            REGISTRATION_FLOW
          </p>
          <h1 className="max-w-2xl font-headline text-3xl font-bold uppercase tracking-tight text-white sm:text-4xl">
            Workshop registration
          </h1>
          <p className="mt-4 max-w-xl text-kinetic-on-surface-variant">
            Secure your seat, choose preferences, and complete payment in a few guided steps.
          </p>
        </Container>
      </div>
      <Container width="large" size="custom" className="pb-16">
        <RegistrationWizard
          workshopId={workshopId || undefined}
          onComplete={handleRegistrationComplete}
          onCancel={handleCancel}
        />
      </Container>
      <KineticWorkshopFooter />
    </KineticPageShell>
  )
}

export default function WorkshopRegistrationPage() {
  return (
    <Suspense
      fallback={
        <KineticPageShell>
          <KineticLoadingCard message="Loading registration form" />
          <KineticWorkshopFooter />
        </KineticPageShell>
      }
    >
      <RegistrationContent />
    </Suspense>
  )
}
